export default "__VITE_ASSET__d3e938c3__"